import { TFunction } from 'react-i18next'
import { yupSchema } from 'utils/yupSchema'
import * as yup from 'yup'

export const schema = (t: TFunction<'common'>) => {
  yupSchema(t)

  return yup.object().shape({
    password: yup.string().required('Senha é obrigatória!').isStrongPassword(),

    confirmPassword: yup
      .string()
      .required('Confirmação da senha é obrigatória!')
      .oneOf([yup.ref('password'), null], 'As senhas devem ser iguais'),
  })
}
